import React, { useEffect, useState } from "react";
import AuthLink from "../../Auth/AuthLink";
import { Result, Button, Spin } from "antd";
import { SmileOutlined, FrownOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../../../const/axios";

type Status = "pending" | "success" | "failed";

export const Confirm = () => {
  const params = useParams();
  const { t } = useTranslation();
  const [status, setStatus] = useState<Status>("pending");
  const [message, setMessage] = useState("");

  useEffect(() => {
    // The code is single-use, so this must fire exactly once per link.
    if (params.code === undefined || params.email === undefined) {
      setStatus("failed");
      setMessage(t("auth.confirmLinkInvalid"));
      return;
    }

    let cancelled = false;
    const confirmUser = async () => {
      try {
        const res = await api.put("auth/confirm", {
          email: params.email,
          code: params.code,
        });
        if (cancelled) return;
        setStatus(res.data.success ? "success" : "failed");
        setMessage(res.data.message || t("auth.confirmLinkInvalid"));
      } catch {
        if (cancelled) return;
        setStatus("failed");
        setMessage(t("auth.operationError"));
      }
    };
    confirmUser();
    return () => {
      cancelled = true;
    };
  }, [params.code, params.email, t]);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 pt-16 flex items-center justify-center px-4">
      {status === "pending" ? (
        <Result icon={<Spin size="large" />} title={t("auth.confirmingAccount")} />
      ) : (
        <Result
          icon={status === "success" ? <SmileOutlined /> : <FrownOutlined />}
          title={status === "success" ? message : t("auth.confirmFailedTitle")}
          subTitle={status === "success" ? undefined : message}
          extra={
            <>
              {/* An expired code is re-sent on the next login attempt, so send
                  both outcomes to the same place. */}
              <AuthLink mode="login" next="/">
                <Button type="primary">{t("auth.goToLogin")}</Button>
              </AuthLink>
              <Link to="/">
                <Button>{t("common.returnHome")}</Button>
              </Link>
            </>
          }
        />
      )}
    </div>
  );
};
